(() => {
    const menuSidebar = document.querySelector('[data-vd-component="menu-sidebar"]');
    if (!menuSidebar) return;
    const mobileTrigger = document.querySelector(".js-menu-trigger");
    const mainMenu = document.querySelector(".main-menu");
    const sidebarContainer = menuSidebar.querySelector(".sidebar-container");
    const header = document.querySelector('[data-vd-component="header-section"]');
    const menuOverlay = document.querySelector(".menu-overlay");

    if (!mobileTrigger || !mainMenu || !sidebarContainer || !menuOverlay) return;

    const mq = window.matchMedia("(max-width: 90rem)");

    const placeholder = document.createComment("main-menu-placeholder");
    mainMenu.before(placeholder);

    const closeSidebar = () => {
        menuSidebar.classList.remove("visible");
        menuOverlay.classList.remove("visible");
        mobileTrigger.classList.remove("is-open");
        document.body.classList.remove("no-scroll");
        if (header) header.classList.remove("menu-open");
        mainMenu.classList.remove("hidden");
        menuSidebar.querySelectorAll(".submenu-wrapper.visible").forEach((p) => p.classList.remove("visible"));
    };

    const attachToSidebarMenu = () => {
        if (mq.matches) sidebarContainer.append(mainMenu);
        else placeholder.after(mainMenu);
    };

    mobileTrigger.addEventListener("click", (e) => {
        if (!mq.matches) return;

        const isOpen = menuSidebar.classList.toggle("visible");
        if (header) header.classList.toggle("menu-open", isOpen);
        e.currentTarget.classList.toggle("is-open", isOpen);
        menuOverlay.classList.toggle("visible", isOpen);
        document.body.classList.toggle("no-scroll", isOpen);
        mainMenu.classList.toggle("hidden", isOpen);

        if (!isOpen) {
            menuSidebar.querySelectorAll(".submenu-wrapper.visible").forEach((p) => p.classList.remove("visible"));
        }
    });

    menuOverlay.addEventListener("click", () => {
        if (!mq.matches) return;
        closeSidebar();
    });

    const onMqChange = () => {
        if (!mq.matches) closeSidebar();
        attachToSidebarMenu();
    };

    attachToSidebarMenu();

    if (mq.addEventListener) mq.addEventListener("change", onMqChange);
    else mq.addListener(onMqChange);
})();
